import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, httpAction } from '@/api/manage';
import moment from 'moment';
import barChart from "../components/barChart";
import lineChart from "../components/lineChart";
export default {
  name: 'OperationReportModal',
  components: {
    barChart: barChart,
    lineChart: lineChart
  },
  data: function data() {
    return {
      value: [],
      mode2: ['month', 'month'],
      visible: false,
      operationReportVos: [{}],
      siteTree: [],
      form: this.$form.createForm(this),
      validatorRules: {
        siteId: {
          rules: [{
            required: true,
            message: '请选择站点!'
          }]
        },
        factorCode: {
          rules: [{
            required: true,
            message: '请选择因子!'
          }]
        }
      },
      queryParam: {},
      showChart: false,
      image: '',
      inspectionData: [],
      inspectionXData: [],
      pageChartTitle: '巡检情况统计',
      image1: '',
      hitchStatData: [],
      hitchStatXData: [],
      pageChartTitle1: '水站故障异常情况统计',
      image2: ''
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().subtract(1, 'months'),
      max: moment(moment().format('YYYY-MM'))
    };
    this.value = [this.limitSelectDate.min, this.limitSelectDate.max];
    this.queryParam.sdateBack = this.limitSelectDate.min.format('YYYY-MM');
    this.queryParam.edateBack = this.limitSelectDate.max.format('YYYY-MM');
    this.getSiteTree();
  },
  methods: {
    handleOk: function handleOk() {
      var _this = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          var operationReportVos = [];
          var factorCodes = '';
          values['siteId'].forEach(function (item, index) {
            if (values['factorCode'][index]) {
              factorCodes = values['factorCode'][index].join(',');
            } else {
              factorCodes = '';
            }

            var obj = {
              siteId: item,
              factorCodes: factorCodes
            };
            operationReportVos.push(obj);

            _this.operationReportVos.forEach(function (item1, index1) {
              if (item == item1.siteId) {
                item1['factorCodes'] = obj.factorCodes;
              }
            });
          });

          var hide = _this.$message.loading('word正在生成中', 0);

          var p = new Promise(function (resolve, reject) {
            //  巡检情况统计
            var siteIdList = [];
            var siteIds;
            operationReportVos.forEach(function (item) {
              siteIdList.push(item.siteId);
            });
            siteIds = siteIdList.join(',');
            var param = {
              sdateBack: _this.queryParam.sdateBack,
              edateBack: _this.queryParam.edateBack,
              siteIds: siteIds,
              pageSize: -1
            };
            getAction('/inspection/find/year/report', param).then(function (res) {
              if (res.success) {
                _this.inspectionData = res.result.records;
                _this.inspectionXData = [];

                for (var item in _this.inspectionData[0]) {
                  if (item != 'siteName' && item != 'totalCount') {
                    _this.inspectionXData.push(item);
                  }
                }

                var data = {
                  xData: _this.inspectionXData,
                  yData: [{
                    type: 'value'
                  }]
                };
                var columnsData = _this.inspectionData;
                columnsData.forEach(function (item) {
                  item['data'] = [];
                  data.xData.forEach(function (item1) {
                    if (item.dataIndex != 'siteName' && item.dataIndex != 'totalCount') {
                      item['data'].push(item[item1]);
                      item['title'] = item.siteName;
                    }
                  });
                });
                setTimeout(function () {
                  console.log('data', data);
                  console.log('columnsData', columnsData);

                  _this.$refs.chart.initBarChart(data, columnsData, _this.pageChartTitle, resolve);
                }, 1000);
              } else {
                _this.$message.warning('系统异常=>' + res.message);
              }
            });
          });
          var p1 = new Promise(function (resolve, reject) {
            // 获取故障/异常统计的xData
            getAction('/sys/dict/getDictItems/failure_cause').then(function (res) {
              if (res.success) {
                var columnsData = [];
                res.result.forEach(function (item) {
                  columnsData.push({
                    title: item.title,
                    dataIndex: item.value,
                    data: []
                  });
                });
                var siteIdList = [];
                var siteIds;
                operationReportVos.forEach(function (item) {
                  siteIdList.push(item.siteId);
                });
                siteIds = siteIdList.join(',');
                var param = {
                  siteIds: siteIds,
                  pageSize: -1
                };
                getAction('/ea/asset/repair/report', param).then(function (res) {
                  if (res.success) {
                    _this.hitchStatData = res.result.records;
                    _this.hitchStatXData = [];

                    _this.hitchStatData.forEach(function (item) {
                      if (item.siteName !== '合计') {
                        _this.hitchStatXData.push(item.siteName);
                      }
                    });

                    var data = {
                      xData: _this.hitchStatXData,
                      yData: [{
                        type: 'value'
                      }]
                    };

                    _this.hitchStatData.forEach(function (item1) {
                      columnsData.forEach(function (item2) {
                        if (item1.siteName !== '合计') {
                          item2.data.push(item1[item2.dataIndex]);
                        }
                      });
                    });

                    setTimeout(function () {
                      console.log('data', data);
                      console.log('columnsData', columnsData);

                      _this.$refs.chart1.initBarChart(data, columnsData, _this.pageChartTitle1, resolve);
                    }, 1000);
                  }
                });
              }
            });
          });
          var p2 = new Promise(function (resolve, reject) {
            //  获取站点因子图表
            var promiseList = [];
            operationReportVos.forEach(function (item, index) {
              var param = {
                type: 6,
                dataType: 5,
                stime: _this.queryParam.sdateBack,
                etime: _this.queryParam.edateBack,
                factorCodes: item.factorCodes,
                scopeId: item.siteId,
                scope: 1
              };
              var p4 = new Promise(function (resolve1, reject1) {
                getAction('/online/st21/efficient', param).then(function (res) {
                  if (res.success) {
                    var Xdata = [];
                    var factorData = res.result.records;
                    var columnsData = [{
                      name: '监测数量完成率',
                      type: 'line',
                      data: []
                    }, {
                      name: '数据有效率',
                      type: 'line',
                      data: []
                    }];

                    if (factorData.length > 0) {
                      factorData.forEach(function (item1) {
                        Xdata.push(item1.dataTime);
                        columnsData.forEach(function (item2) {
                          if (item2.name == '监测数量完成率') {
                            var minCompletionRate = parseFloat(item1.attrs.minCompletionRate);
                            item2.data.push(minCompletionRate);
                          } else if (item2.name == '数据有效率') {
                            var minEfficient = parseFloat(item1.attrs.minEfficient);
                            item2.data.push(minEfficient);
                          }
                        });
                      });
                    }

                    var data = {
                      xData: Xdata,
                      yData: [{
                        type: 'value'
                      }]
                    };
                    setTimeout(function () {
                      _this.$refs['lineChart' + index][0].initBarChart(data, columnsData, index, resolve1);
                    }, 1000);
                  }
                });
              });
              promiseList.push(p4);
            });
            Promise.all(promiseList).then(function (data) {
              resolve('5555');
            });
          });
          var p3 = Promise.all([p, p1, p2]);
          p3.then(function (data) {
            var params = {
              image1: _this.image1,
              image2: _this.image2,
              operationReportVos: _this.operationReportVos,
              startTime: _this.queryParam.sdateBack,
              endTime: _this.queryParam.edateBack
            };
            console.log('params', JSON.parse(JSON.stringify(params)));
            httpAction('/om/operation/report/word', params, 'post').then(function (res) {
              if (res) {
                var filename = _this.queryParam.sdateBack + '至' + _this.queryParam.edateBack + '运维报告.doc';
                var blob = new Blob([res], {
                  type: 'application/msword;charset=utf-8'
                });
                var a = document.createElement('a');
                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
                var body = document.getElementsByTagName('body')[0];
                body.appendChild(a);
                a.click();
                body.removeChild(a);

                _this.$message.destroy(hide);

                window.URL.revokeObjectURL(url);

                _this.$message_custom('生成word成功');

                _this.queryParam.sdateBack = _this.limitSelectDate.min.format('YYYY-MM');
                _this.queryParam.edateBack = _this.limitSelectDate.max.format('YYYY-MM');
                _this.operationReportVos = [{}];

                _this.form.resetFields();
              } else {
                _this.$message.destroy(hide);

                _this.$message_custom('系统异常', 'warning');
              }
            });
          });
          _this.visible = false;
        }
      });
    },
    getSiteTree: function getSiteTree() {
      var _this2 = this;

      getAction('/online/env/api/queryTreeList?addrType=1').then(function (res) {
        if (res.success) {
          _this2.reviseTree(res.result);

          _this2.siteTree = res.result;

          _this2.$forceUpdate();
        }
      });
    },
    reviseTree: function reviseTree(tree) {
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];

        if (node.children) {
          node['disabled'] = true;
          this.reviseTree(node.children);
        } else {
          node['disabled'] = false;
        }
      }
    },
    listAdd: function listAdd() {
      this.operationReportVos.push({});
    },
    listDelete: function listDelete(index) {
      this.operationReportVos.splice(index, 1);
    },
    //  站点选择框
    siteTreeChange: function siteTreeChange(e, label, index) {
      var _this3 = this;

      getAction('/site/info/factor/find/' + e).then(function (res) {
        if (res.success) {
          _this3.operationReportVos[index]['factorCodeList'] = res.result;
          _this3.operationReportVos[index]['title'] = label[0];
          _this3.operationReportVos[index]['siteId'] = e;

          _this3.$forceUpdate();
        }
      });
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.sdateBack = dateString[0];
      this.queryParam.edateBack = dateString[1];
    },
    handlePanelChange: function handlePanelChange(value, mode) {
      this.value = value;
      this.queryParam.sdateBack = value[0].format('YYYY-MM');
      this.queryParam.edateBack = value[1].format('YYYY-MM');
    },
    getImage: function getImage(image, title) {
      if (title == '水站故障异常情况统计') {
        this.image2 = image;
      } else if (title == '巡检情况统计') {
        this.image1 = image;
      }
    },
    lineChartIamge: function lineChartIamge(image, index) {
      this.operationReportVos[index]['image'] = image;
    }
  }
};